var map = {
	"./_chart.svg": 1249,
	"./account.svg": 726,
	"./americanexpress.svg": 1250,
	"./analytics.svg": 1251,
	"./arrow-button.svg": 1252,
	"./arrow-down.svg": 1253,
	"./arrow-dropdown.svg": 1254,
	"./arrow-left.svg": 1255,
	"./bell.svg": 727,
	"./beta.svg": 1256,
	"./billing.svg": 1257,
	"./calendar.svg": 1258,
	"./channel/365scores.svg": 1259,
	"./channel/adform.svg": 1260,
	"./channel/adrecord.svg": 1261,
	"./channel/adroll.svg": 1262,
	"./channel/adsterra.svg": 1263,
	"./channel/adtraction.svg": 1264,
	"./channel/adviralmedia.svg": 1265,
	"./channel/adwords.svg": 1266,
	"./channel/adxad.svg": 1267,
	"./channel/apprl.svg": 1268,
	"./channel/appstore.svg": 1269,
	"./channel/apptraffic.svg": 1270,
	"./channel/article.svg": 1271,
	"./channel/automation.svg": 1272,
	"./channel/besoccer.svg": 1273,
	"./channel/betfans.svg": 1274,
	"./channel/betgenius.svg": 1275,
	"./channel/bing.svg": 1276,
	"./channel/bingo.svg": 1277,
	"./channel/blog.svg": 1278,
	"./channel/cart_abandonment.svg": 1279,
	"./channel/casinonieuws.nl.svg": 1280,
	"./channel/casinoscout.nl.svg": 1281,
	"./channel/cellxpert.svg": 1282,
	"./channel/cleveradvertising.svg": 1283,
	"./channel/clickadilla.svg": 1284,
	"./channel/clickbank.svg": 1285,
	"./channel/commisionjunction.svg": 1286,
	"./channel/criteo.svg": 1287,
	"./channel/custom_upload.svg": 1288,
	"./channel/customerservice.svg": 1289,
	"./channel/direct.svg": 1290,
	"./channel/display.svg": 1291,
	"./channel/double.net.svg": 1292,
	"./channel/dpg.svg": 1293,
	"./channel/duckduckgo.svg": 1294,
	"./channel/dummy.svg": 1295,
	"./channel/email.svg": 1296,
	"./channel/engaged.svg": 1297,
	"./channel/exit_intent.svg": 1298,
	"./channel/external.svg": 1299,
	"./channel/ezmob.svg": 1300,
	"./channel/facebook.svg": 1301,
	"./channel/fcupdate.svg": 1302,
	"./channel/forum.svg": 1303,
	"./channel/gambling.com.svg": 1304,
	"./channel/geniee.svg": 1305,
	"./channel/google.svg": 1306,
	"./channel/googlecampaignmanager.svg": 1307,
	"./channel/highvalueppc.svg": 1308,
	"./channel/highvalueseo.svg": 1309,
	"./channel/igmn.svg": 1310,
	"./channel/incomeaccess.svg": 1311,
	"./channel/influencers.svg": 1312,
	"./channel/instagram.svg": 1313,
	"./channel/internalbrand.svg": 1314,
	"./channel/internalgeneric.svg": 1315,
	"./channel/internalsocial.svg": 1316,
	"./channel/intikkertje.nl.svg": 1317,
	"./channel/itp.svg": 1318,
	"./channel/juicyads.svg": 1319,
	"./channel/klarna.svg": 1320,
	"./channel/landbased.svg": 1321,
	"./channel/linkedin.svg": 1322,
	"./channel/linkshare.svg": 1323,
	"./channel/livecasino.svg": 1324,
	"./channel/livescore.svg": 1325,
	"./channel/match2one.svg": 1326,
	"./channel/mediahuis.svg": 1327,
	"./channel/mediamath.svg": 1328,
	"./channel/meneercasino.nl.svg": 1329,
	"./channel/mgid.svg": 1330,
	"./channel/mmedia.svg": 1331,
	"./channel/motorsport.com.svg": 1332,
	"./channel/mythings.svg": 1333,
	"./channel/networkmisc.svg": 1334,
	"./channel/newsletter.svg": 1335,
	"./channel/onlinecasinoground.nl.svg": 1336,
	"./channel/otherppc.svg": 1337,
	"./channel/others.svg": 1338,
	"./channel/otherseo.svg": 1339,
	"./channel/phoenixads.svg": 1340,
	"./channel/pinterest.svg": 1341,
	"./channel/popads.svg": 1342,
	"./channel/pricerunner.svg": 1343,
	"./channel/propellerads.svg": 1344,
	"./channel/push_notice.svg": 1345,
	"./channel/quora.svg": 1346,
	"./channel/rakuten.svg": 1347,
	"./channel/reddit.svg": 1348,
	"./channel/reminder.svg": 1349,
	"./channel/richads.svg": 1350,
	"./channel/shareasale.svg": 1351,
	"./channel/sms.svg": 1352,
	"./channel/snapchat.svg": 1353,
	"./channel/sociomantic.svg": 1354,
	"./channel/sportradar.svg": 1355,
	"./channel/streamer.svg": 1356,
	"./channel/tiktok.svg": 1357,
	"./channel/tradedesk.svg": 1358,
	"./channel/tradedoubler.svg": 1359,
	"./channel/tradetracker.svg": 1360,
	"./channel/trafficjunky.svg": 1361,
	"./channel/trafficstars.svg": 1362,
	"./channel/transaction.svg": 1363,
	"./channel/trustpilot.svg": 1364,
	"./channel/twinred.svg": 1365,
	"./channel/twitter.svg": 1366,
	"./channel/type_.svg": 1367,
	"./channel/type_audio.svg": 1368,
	"./channel/type_display.svg": 1369,
	"./channel/type_display_dynamic.svg": 1370,
	"./channel/type_in_house.svg": 1371,
	"./channel/type_native.svg": 1372,
	"./channel/type_sportradar.svg": 1373,
	"./channel/type_video.svg": 1374,
	"./channel/unknown.svg": 1375,
	"./channel/vk.svg": 1376,
	"./channel/voetbalgokken.nl.svg": 1377,
	"./channel/webgains.svg": 1378,
	"./channel/yahoo.svg": 1379,
	"./channel/yandex.svg": 1380,
	"./channel/youtube.svg": 1381,
	"./channel/zanox.svg": 1382,
	"./channels.svg": 1383,
	"./chart.svg": 1384,
	"./chevron.svg": 1385,
	"./chevrons-double.svg": 1386,
	"./conversion.svg": 1387,
	"./conversion/FTD.svg": 1388,
	"./conversion/Reg finished.svg": 1389,
	"./conversion/other.svg": 1390,
	"./coppy.svg": 1391,
	"./costs.svg": 1392,
	"./cross.svg": 1393,
	"./customer.svg": 397,
	"./customers.svg": 1394,
	"./dashboard.svg": 1395,
	"./delete.svg": 1396,
	"./details.svg": 1397,
	"./device-desktop.svg": 1398,
	"./device-mobile.svg": 1399,
	"./device-tablet.svg": 1400,
	"./display/hasImpression.svg": 1401,
	"./display/onlyRegFin.svg": 1402,
	"./dots.svg": 1403,
	"./down.svg": 1404,
	"./drop.svg": 1405,
	"./edit.svg": 1406,
	"./expand.svg": 1407,
	"./eye.svg": 1408,
	"./filter.svg": 1409,
	"./flake.svg": 1410,
	"./fold.svg": 1411,
	"./funnel.svg": 1412,
	"./generic_card.svg": 1413,
	"./google-tag-manager.svg": 1414,
	"./hamburger.svg": 1415,
	"./integration-api.svg": 1416,
	"./integration-manual-input.svg": 1417,
	"./integration-spreadsheet.svg": 1418,
	"./integrations.svg": 1419,
	"./landing-pages.svg": 1420,
	"./magento.svg": 1421,
	"./mastercard.svg": 1422,
	"./multi-wizard.svg": 1423,
	"./new-arrow-up.svg": 1424,
	"./new-cross.svg": 1425,
	"./new-customer.svg": 1426,
	"./new-plus.svg": 1427,
	"./order.svg": 1428,
	"./orderType-new.svg": 1429,
	"./orderType-repeat.svg": 1430,
	"./orders-explorer.svg": 1431,
	"./orders.svg": 1432,
	"./paypal.svg": 1433,
	"./plus.svg": 1434,
	"./popup-tail.svg": 1435,
	"./prestashop.svg": 1436,
	"./product.svg": 1437,
	"./question.svg": 1438,
	"./report.svg": 1439,
	"./sessionType-customer.svg": 1440,
	"./sessionType-new.svg": 1441,
	"./sessionType-repeat.svg": 1442,
	"./settings.svg": 1443,
	"./shopify.svg": 1444,
	"./shopware.svg": 1445,
	"./singlePageview-0.svg": 1446,
	"./singlePageview-1.svg": 1447,
	"./small-wizard.svg": 1448,
	"./star.svg": 1449,
	"./tick.svg": 1450,
	"./time.svg": 1451,
	"./tooltip-question.svg": 1452,
	"./traffic.svg": 1453,
	"./trash.svg": 1454,
	"./trial-medium.svg": 1455,
	"./trial.svg": 1456,
	"./turn-off.svg": 1457,
	"./upload.svg": 1458,
	"./visa.svg": 1459,
	"./visit.svg": 1460,
	"./warning.svg": 1461,
	"./woo.svg": 1462,
	"./wrench.svg": 728,
	"./zoom.svg": 1463
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1248;


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images ^\.\/.*\.svg$
// module id = 1248
// module chunks = 0